import React from 'react';

import { AccountItem } from './AccountItem';
import { AccountLink } from './AccountLink';
import * as styles from './AccountPopover.styles';
import { FAVOURITES_PAGE_HREF } from 'client-site-chrome-ui/constants/hrefs';

interface AuthenticatedAccountLinksProps {
  includeFavourites: boolean;
  member?: boolean;
}

export const AuthenticatedAccountLinks = ({
  includeFavourites,
  member = false,
}: AuthenticatedAccountLinksProps) => (
  <div css={styles.sections}>
    {member && (
      <section css={styles.membershipSection}>
        <AccountItem text="NOTHS & More Member" />
      </section>
    )}
    <section>
      <ul css={styles.list}>
        {includeFavourites && (
          <li css={styles.smallScreensOnly}>
            <AccountLink href={FAVOURITES_PAGE_HREF} text="My Favourites" />
          </li>
        )}
        <li>
          <AccountLink href="/user/orders" text="My Orders" />
        </li>
        <li>
          <AccountLink href="/user" text="My Details" />
        </li>
        <li>
          <AccountLink href="/u/addresses/manage" text="My Addresses" />
        </li>
        <li>
          <AccountLink href="/u/password/new" text="My Password" />
        </li>
        <li>
          <AccountLink href="/user/account" text="My Funds" />
        </li>
        <li>
          <AccountLink href="/u/marketing-preferences" text="My Marketing Preferences" />
        </li>
      </ul>
    </section>
    <br />
    <section>
      <AccountLink href="/u/sign-out" text="Sign out" />
    </section>
  </div>
);
